import { Navigate } from 'react-router-dom';
import type { RoleCode } from '@app/shared';
import { useAuth } from '../features/auth/use-auth';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRoles?: RoleCode[];
}

export function ProtectedRoute({ children, requiredRoles }: ProtectedRouteProps) {
  const { status, user } = useAuth();

  if (status === 'idle' || status === 'loading') {
    return <div style={{ padding: '2rem', textAlign: 'center' }}>Memuat sesi...</div>;
  }

  if (status === 'unauthenticated' || !user) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRoles && requiredRoles.length > 0) {
    const hasRole = user.roles.some((role) => requiredRoles.includes(role));
    if (!hasRole) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return <>{children}</>;
}
